import { render, staticRenderFns } from "./DataType.vue?vue&type=template&id=59eb884a&scoped=true&"
import script from "./DataType.vue?vue&type=script&lang=js&"
export * from "./DataType.vue?vue&type=script&lang=js&"
import style0 from "./DataType.vue?vue&type=style&index=0&id=59eb884a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59eb884a",
  null
  
)

export default component.exports